module.exports = __webpack_public_path__ + "img/stream-logo.758895b1.png";